
export default {
  name: 'InfoNonRefermable',
  props: {
    titre: {
      type: String,
      required: true
    },
    couleur: {
      type: String,
      default: 'bleu-marine'
    },
    titreEstSouligne: {
      type: Boolean,
      default: true
    },
    grandeurTitre: {
      type: Number,
      default: 3
    }
  },
  computed: {
    couleurEstBleu () {
      return this.couleur === 'bleu-marine'
    },
    couleurFond () {
      return this.couleurEstBleu ? 'fond--marine-leger' : 'fond--orange-leger'
    },
    couleurTexte () {
      return this.couleurEstBleu ? 'texte--bleu-marine' : 'texte--orange'
    },
    style () {
      return {
        'border-bottom': (this.titreEstSouligne) ? '3px solid' : '0',
        'padding-bottom': (this.titreEstSouligne) ? 'relation(ami-proche)' : '0'
      }
    }
  }
}
